import { requestWrapper } from '@/utils/axiosInstance';

export default {
  async getAll(query) {
    return await requestWrapper(null, 'GET', '/docs', query);
  },
  async create(doc) {
    return await requestWrapper(null, 'POST', '/docs', null, doc);
  },
  async check(query) {
    return await requestWrapper(null, 'GET', '/documents/check', query);
  },
  async get(id) {
    return await requestWrapper(null, 'GET', `/docs/${id}`);
  },
  async update(doc) {
    return await requestWrapper(null, 'PUT', `/docs/${doc.id}`, null, doc);
  },
  async remove(id) {
    return await requestWrapper(null, 'DELETE', `/docs/${id}`);
  },
  async getHTML(id) {
    return await requestWrapper(null, 'GET', `/document_text/${id}`);
  },
  async updateNote(note) {
    return await requestWrapper(null, 'PUT', `/notes`, null, note);
  },
  async saveImages(images) {
    return await requestWrapper(null, 'POST', '/document_images', null, images, true);
  },
  async removeImage(id) {
    return await requestWrapper(null, 'DELETE', `/document_images/${id}`);
  },
};
